<template>
  <CChartLine
    :datasets="defaultDatasets"
    :options="defaultOptions"
    :labels="this.$parent.MemberWithdrawChartLabel"
  />
  <!-- :labels="['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']" -->
</template>

<script>
import { CChartLine } from '@coreui/coreui-vue-chartjs'
import { getColor, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'MemberWithdrawChart',
  components: {
    CChartLine
  },
  computed: {
    defaultDatasets () {
      const brandDanger = getColor('danger') || '#f86c6b'
      //const brandInfo = getColor('info') || '#20a8d8'


      //const data1 =[0,0,0,0,0,2,0,3,0,1,0,0,0,3,0,0,8,0,0,0,0,0,0,1]
      //const a=Math.max.apply(Math,this.data1)


      return [
        {
          label: 'Member Withdraw',
          backgroundColor: hexToRgba(brandDanger, 10),
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 2,
          data: this.$parent.MemberWithdrawChartData
        }
      ]
    },
    defaultOptions () {
      return {

        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 10,
              stepSize: Math.ceil(this.a / 5),
              max: this.a
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chart/MemberWithdrawChart.vue